import siteSearchGroup from '@/components/search-group.vue'
// import journal from '@/api/journal'
import abstractModal from './abstract.dialog'
import { reviewerInvite } from '@/api/reviewer'
import { mapGetters, mapActions } from 'vuex'
import file from '@/api/file'
import { REVIEWER_STATUS } from '@/utils/dict'
import SendEmail from '../../editorial-office/manuscripts/dialog/send-email.dialog'
import detailReport from './detail-report.vue'
import CreatePNG from '@/components/createPNG.dialog.vue'
import manuscript from '@/api/manuscript'

const NewInvitationColumns = [
  {
    title: '',
    enTitle: '',
    width: 80,
    dataIndex: 'cover',
    slot: 'img'
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 120,
    dataIndex: 'manuscriptId',
    slot: 'manuscriptNo'
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 280,
    dataIndex: 'title',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Editor',
    width: 160,
    dataIndex: 'editor',
    slot: 'editor'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 140,
    dataIndex: 'status',
    slot: 'status'
  },
  // {
  //   title: '',
  //   enTitle: 'Revision Due Date',
  //   width: 160,
  //   dataIndex: 'dueDate',
  //   slot: 'time'
  // },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
const columns = [
  {
    title: '',
    enTitle: '',
    width: 80,
    dataIndex: 'cover',
    slot: 'img'
  },
  {
    title: '',
    enTitle: 'Manuscript No.',
    width: 120,
    dataIndex: 'manuscriptId',
    slot: 'manuscriptNo'
  },
  {
    title: '',
    enTitle: 'Article Title',
    width: 280,
    dataIndex: 'title',
    slot: 'omission'
  },
  {
    title: '',
    enTitle: 'Editor',
    width: 160,
    dataIndex: 'editor',
    slot: 'editor'
  },
  {
    title: '',
    enTitle: 'Review Status',
    width: 140,
    dataIndex: 'status',
    slot: 'status'
  },
  {
    title: '',
    enTitle: 'Revision Due Date',
    width: 160,
    dataIndex: 'dueDate',
    slot: 'time'
  },
  {
    title: '',
    enTitle: 'Actions',
    width: 150,
    dataIndex: 'actions',
    fixed: 'right',
    slot: 'actions'
  }
]
export default {
  components: {
    siteSearchGroup,
    abstractModal,
    SendEmail,
    detailReport,
    CreatePNG
  },
  data() {
    return {
      reviewerStatus: REVIEWER_STATUS,
      params: {
        keyword: '',
        // journalId: '',
        invitationStatus: 'NEW_INVITATIONS'
      },
      journalList: [],
      count: [],
      reviewerInvite: reviewerInvite,
      titleStatus: {
        NEW_INVITATIONS: 'New Invitation',
        ACCEPT_INVITATIONS: 'Pending Review',
        COMPLETED_INVITATIONS: 'Completed Report'
      },
      emptyText: {
        NEW_INVITATIONS: 'There is no review invitation.',
        ACCEPT_INVITATIONS: 'There is no manuscript pending your report.',
        COMPLETED_INVITATIONS: `You haven't decided on any manuscript yet.`
      },
      countStatus: {},
      columns: {
        NEW_INVITATIONS: NewInvitationColumns,
        ACCEPT_INVITATIONS: columns,
        COMPLETED_INVITATIONS: columns
      },
      pagination: {
        total: 0,
        size: 50,
        current: 1,
        sizeChange: true,
        onPageChange: this.getList,
        showSizeChange: this.getList,
        pageSizeOptions: [5, 10, 30, 50, 100], // 每页数量选项
        showQuickJumper: true
      },
      dataSource: [],
      isVisable: false,
      abstractDetail: '',

      showSendEmail: false,
      inputData: {},
      showDetail: false,
      pdfType: 'rc-c',
      isVisablePDF: false
    }
  },
  computed: {
    ...mapGetters({ domain: 'getDomain' })
  },
  async mounted() {
    // await this.getJournalList()
    await this.getList()
  },
  methods: {
    ...mapActions(['updateDomain']),
    async getDomain() {
      const domain = await file.domain()
      this.updateDomain(domain)
    },
    async getCount() {
      this.countStatus = await reviewerInvite.count(this.params)
    },
    async getList(page, size) {
      if (!page) {
        page = 1
      }
      if (!size) {
        size = this.pagination.size
      }
      const data = Object.assign(this.params, {
        pageIndex: page,
        pageSize: size
      })
      this.dataSource = []
      const { list, pageIndex, pageSize, total } = await reviewerInvite.reviews(
        data
      )
      this.dataSource = list
      this.pagination = Object.assign(this.pagination, {
        total,
        size: pageSize,
        current: pageIndex
      })
      this.getCount()
    },
    handleClear() {
      this.params.keyword = ''
      // this.params.journalId = ''
      this.getList()
    },
    // async getJournalList() {
    //   this.journalList = await journal.reviewerGet({ released: true })
    //   const flag = this.journalList.some(item => {
    //     if (item.id === localStorage.getItem('rejournalId')) {
    //       this.params.journalId = item.id
    //       return true
    //     }
    //   })
    //   if (!flag) {
    //     this.params.journalId = this.journalList[0] && this.journalList[0].id
    //     localStorage.setItem('rejournalId', this.params.journalId)
    //   }
    // },
    changeJournal() {
      this.getList()
      // localStorage.setItem('rejournalId', val)
    },
    submit() {
      // this.$router.push('/reviewers-menu/reviews/reviews-detail')
    },
    changeStatus(key) {
      this.params.invitationStatus = key
      this.getList()
    },
    detail(val) {
      // this.$router.push(`/reviewers-menu/reviews/reviews-detail/${val.id}`)
      // this.$router.push(`/reviewers-menu/reviews/review-detail/${val.id}`)
      this.showDetail = true
      this.inputData = val
    },
    // 查看摘要
    abstract(val) {
      this.isVisable = true
      this.abstractDetail = val.summary
    },
    // 同意审稿 状态
    async able(val, status) {
      let data = {
        id: val.id,
        status: status,
        version: val.version
      }
      await reviewerInvite.confirm(data)
      this.changeStatus('ACCEPT_INVITATIONS')
    },
    // 拒绝审稿
    unable(val) {
      this.$router.push(
        `/reviewers-menu/reviews/reviews-refuse?id=${val.id}&version=${val.version}`
      )
    },
    // 提交决策
    commit(val) {
      this.$router.push(
        // `/reviewers-menu/reviews/reviews-agree/agreed?id=${val.manuscriptId}&sign=${val.sign}`
        `/reviewers-menu/reviews/reviews-agree?id=${val.id}`
      )
    },
    // 申请延时
    sendEmail(val) {
      this.showSendEmail = true
      this.inputData = {
        reviewerPersonId: val.personId,
        minvitedReviewerId: val.id,
        manuscriptId: val.manuscriptId,
        sign: val.sign,
        journalId: (val.journal && val.journal.id) || val.journalId
      }
    },

    // 生成证书
    async createCanvans(val, type) {
      const res = await manuscript.certificate(val.id)
      this.inputData = res
      this.pdfType = type
      this.isVisablePDF = true
    },
    // 关闭弹窗
    cancel() {
      this.isVisable = false
      this.showSendEmail = false
      this.showDetail = false
      this.isVisablePDF = false
    }
  }
}
